// import * as logicAnnuncio from "@logic/annuncio";
// import SelectCategory from "@templates/selectCategory";
// import SelectProvince from "@templates/selectProvince";
// import TextInput from '@components/textInput';
// import { useDispatch } from "react-redux";
import * as apiPublic from "@api/public";
import * as apiUser from "@api/user";
import AnnuncioPreview from '@templates/annunci/AnnuncioPreview';
import Button from "@components/button";
import Card from "@components/card";
import Icon from "@components/icon";
import React, {useMemo, useState, useCallback, useEffect } from "react";
import moment from 'moment';
import styles from "./AnnuncioGestisci.module.css";
import { ROUTES, useNavigator } from "@contexts/NavigatorContext";
import { getStatoAnnuncio } from "@logic/annuncio";
import { useModals } from "@contexts/ModalsContext";
import { ServiceTypeLabels, ValidationStatusLabels, ServiceType } from "@api/apiEnum";

const AnnuncioGestisci = () => {
  const { navigate, currentRoute } = useNavigator();
  const { openModal, closeAllModals } = useModals();

  const [loading, setLoading] = useState(false);
  const [annuncio, setAnnuncio] = useState(null);

  const idAnnuncio = currentRoute.params[0];

  const statoAnnuncio = useMemo(() => getStatoAnnuncio(annuncio), [annuncio]);

  const formatCents = (cents) => (cents / 100).toFixed(2).replace('.', ',');

  const loadAnnuncio = useCallback(() => {
    setLoading(true);
    apiPublic.GetAdvertisement({ advertisementId: idAnnuncio })
      .then((data) => setAnnuncio(data))
      .finally(() => setLoading(false));
  }, [idAnnuncio])

  const deleteAdvertisement = useCallback(() => {
    setLoading(true);
    apiUser.DeleteAdvertisement({ advertisementId: idAnnuncio })
      .then(() => navigate(ROUTES.I_MIEI_ANNUNCI))
      .finally(() => setLoading(false));
  }, [idAnnuncio, navigate])

  const askDeleteAdvertisement = useCallback(() => {
    openModal({
      title: "Elimina annuncio",
      children: <>
        <div className='row'>
          <div className='col'>
            <span>Confermi l'eliminazione dell'annuncio '{annuncio?.title}'?</span>
          </div>
        </div>
        <div className='row'>
          <div className='col col-flex-center'>
            <Button
              color="primary"
              icon="delete"
              onClick={deleteAdvertisement}
              text="Conferma eliminazione"
            />
            <Button
              color="secondary"
              onClick={closeAllModals}
              text="Annulla"
            />
          </div>
        </div>
      </>,
    });
  }, [annuncio?.title, closeAllModals, deleteAdvertisement, openModal]);

  const buyService = (serviceType) => {
    setLoading(true);
    switch(serviceType)
    {
      case 1:
        apiUser.PurchaseFeatured({ advertisementId: idAnnuncio })
          .then((data) => loadAnnuncio())
          .finally(() => setLoading(false));
        break;
      case 2:
        apiUser.PurchasePublishOnline({ advertisementId: idAnnuncio })
          .then((data) => loadAnnuncio())
          .finally(() => setLoading(false));
        break;
      default:
        setLoading(false);
    }
  };

  const suspend = () => {
    setLoading(true);
    apiUser.SuspendAdvertisement({ advertisementId: idAnnuncio })
      .then((data) => loadAnnuncio())
      .finally(() => setLoading(false));
  };

  const republish = () => {
    setLoading(true);
    apiUser.RepublishAdvertisement({ advertisementId: idAnnuncio })
      .then((data) => loadAnnuncio())
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadAnnuncio();
  }, [loadAnnuncio])

  const cardStatoAnnuncio = () => {
    if (!annuncio || !statoAnnuncio) return null;
    const iconDefaultProps = {
      fill: 0,
      grade: 0,
      name: statoAnnuncio.icon,
      opticalSize: 24,
      size: 24,
      weight: 400,
    };
    return (
      <Card>
        <div className='row'>
          <div className='col'>
            <span className='page-section'>Annuncio {statoAnnuncio.text}!</span>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <div className={styles.statoWrapper}>
              <Icon
                {...iconDefaultProps}
                className={[
                  styles.icon,
                  statoAnnuncio.isSuccess ? styles.success : "",
                  statoAnnuncio.error ? styles.error : "",
                  statoAnnuncio.warning ? styles.warning : "",
                ].join(" ")}
              />
              <span>Validazione: {ValidationStatusLabels[annuncio.validationStatus]}</span>
              <span>Scadenza: {annuncio.isExpired ? "Scaduto il " : ""}{moment(annuncio.expirationDate).format("D MMMM YYYY")}</span>
              {/* <span>Pagamento: Gratuito</span> */}
              <span>Sospeso: {annuncio.isSuspended ? "Si" : "No"}</span>
              <span>Evidenza: {annuncio.isFeatured ? "Si" : "No"}</span>
              {/* <span>{`${moment(annuncio.expirationDate).diff(annuncio.publishDate, 'days')} giorni restanti`}</span> */}
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col col-flex-center'>
            {!annuncio.isSuspended && !annuncio.isRifiutato ?
              <Button
                color="primary"
                onClick={() => suspend()}
                text="Sospendi"
              />
              : null
            }
            {(annuncio.isExpired || annuncio.isSuspended) && !annuncio.isRifiutato ?
             annuncio.serviceCosts.find(cost => cost.serviceType === ServiceType.PublishOnline).cost > 0 || annuncio.isSuspended ?
            <Button
              color="primary"
              onClick={() => republish()}
              text="Ripubblica"
            />
            :
            <Button
                  color="primary"
                  onClick={() => buyService(ServiceType.PublishOnline)}
                  icon="savings"
                  iconAlignment="right"
                  text={`${ServiceTypeLabels[ServiceType.PublishOnline]} (${formatCents(annuncio.serviceCosts.find(cost => cost.serviceType === ServiceType.PublishOnline).cost)})`}></Button>
            : null
            }
            {!annuncio.isFeatured && !annuncio.isRifiutato && annuncio.serviceCosts.find(cost => cost.serviceType === ServiceType.Featured)?.cost > 0 ?
              <Button
                color="primary"
                onClick={() => buyService(ServiceType.Featured)}
                icon="savings"
                iconAlignment="right"
                text={`${ServiceTypeLabels[ServiceType.Featured]} (${formatCents(annuncio.serviceCosts.find(cost => cost.serviceType === ServiceType.Featured).cost)})`}></Button>
              : null}
          </div>
        </div>
      </Card>
    );
  };

  return (
    <>
      <br></br>
      <div className='row'>
        <div className='col'>
          <span className='page-title'>Gestisci annuncio</span>
        </div>
      </div>
      {annuncio && (
        <>
          <div className='row'>
            <div className='col'>
              <AnnuncioPreview
                annuncio={annuncio}
                loading={loading}
                suppressNavigation
              >
                {!statoAnnuncio.isRifiutato && (
                  <Button
                    color="secondary"
                    icon="edit"
                    onClick={() => navigate(ROUTES.ANNUNCIO_MODIFICA, [annuncio.id])}
                    text="Modifica"
                  />
                )}
                <Button
                  color="secondary"
                  icon="delete"
                  onClick={askDeleteAdvertisement}
                  text="Elimina"
                />
              </AnnuncioPreview>
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              {cardStatoAnnuncio()}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AnnuncioGestisci;
